<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Button" });
import { Span } from "../../typography/index.js";
import Icon from "../icon/Icon.svelte";
import "tailwindcss/tailwind.css";
import { useNavigate } from "svelte-navigator";
const navigate = useNavigate();
export let type = "button";
export let color = "primary";
export let size = "md";
export let style = "solid";
export let isDisabled = false;
export let label = void 0;
export let url = void 0;
export let css = "";
export let icon = "";
export let align = "right";
const navigateToUrl = () => {
    if (typeof url !== "string") {
        return;
    }
    if (url.startsWith("#")) {
        window.location.hash = url;
        return;
    }
    if (url.startsWith("http:") || url.startsWith("https:") || url.startsWith("mailto:")) {
        window.open(url, "_blank");
        return;
    }
    navigate(url);
};
$: labelClass = label === void 0 ? "s8-no-label" : "";
$: classes = `s8-button s8-${size} s8-${color} s8-${style} s8-${align} ${labelClass} ${css}`;
$: iconCss = style === "solid" ? "stroke-light" : `stroke-${color}`;
</script>

<button
    { type }
    class = { classes }
    disabled = { isDisabled }
    on:click = { navigateToUrl }
    on:click
>
    {#if icon && align === 'left'}
        <Icon key = { icon } css = { iconCss } isScaling = { false } />
    {/if}
    {#if label !== undefined}
        <Span { label } />
    {/if}
    {#if icon && align === 'right'}
        <Icon key = { icon } css = { iconCss } isScaling = { false } />
    {/if}
</button>

<!-- eslint-disable max-lines -->

<style>

    button.s8-button {
        position: relative;
        white-space: nowrap;
        border-width: 1px;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
        border-radius: 6px;
}

        button.s8-button :global(svg) {
        position: relative;
        display: inline-block;
        vertical-align: middle;
            top: -1px;
}

        button.s8-button:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
}

        /* Colors */

        button.s8-button.s8-primary {
        border-color: rgba(68, 131, 95, 1);
        background-color: rgba(68, 131, 95, 1);
        color: rgba(68, 131, 95, 1);
}

        button.s8-button.s8-primary :global(svg) {
        stroke: rgba(68, 131, 95, 1);
}

        button.s8-button.s8-primary:hover:not(:disabled) {
        border-color: rgba(45, 96, 67, 1);
        background-color: rgba(45, 96, 67, 1);
        color: rgba(45, 96, 67, 1);
}

        button.s8-button.s8-primary:hover:not(:disabled) :global(svg) {
        stroke: rgba(45, 96, 67, 1);
}

        button.s8-button.s8-primary:active {
        border-color: rgba(31, 71, 48, 1);
        background-color: rgba(31, 71, 48, 1);
        color: rgba(31, 71, 48, 1);
}

        button.s8-button.s8-primary:active :global(svg) {
        stroke: rgba(31, 71, 48, 1);
}

        button.s8-button.s8-secondary {
        border-color: rgba(230, 152, 131, 1);
        background-color: rgba(230, 152, 131, 1);
        color: rgba(230, 152, 131, 1);
}

        button.s8-button.s8-secondary :global(svg) {
        stroke: rgba(230, 152, 131, 1);
}

        button.s8-button.s8-secondary:hover:not(:disabled) {
        border-color: rgba(193, 122, 103, 1);
        background-color: rgba(193, 122, 103, 1);
        color: rgba(193, 122, 103, 1);
}

        button.s8-button.s8-secondary:hover:not(:disabled) :global(svg) {
        stroke: rgba(193, 122, 103, 1);
}

        button.s8-button.s8-secondary:active {
        border-color: rgba(121, 76, 64, 1);
        background-color: rgba(121, 76, 64, 1);
        color: rgba(121, 76, 64, 1);
}

        button.s8-button.s8-secondary:active :global(svg) {
        stroke: rgba(121, 76, 64, 1);
}

        button.s8-button.s8-tertiary {
        border-color: rgba(82, 189, 203, 1);
        background-color: rgba(82, 189, 203, 1);
        color: rgba(82, 189, 203, 1);
}

        button.s8-button.s8-tertiary :global(svg) {
        stroke: rgba(82, 189, 203, 1);
}

        button.s8-button.s8-tertiary:hover:not(:disabled) {
        border-color: rgba(52, 159, 173, 1);
        background-color: rgba(52, 159, 173, 1);
        color: rgba(52, 159, 173, 1);
}

        button.s8-button.s8-tertiary:hover:not(:disabled) :global(svg) {
        stroke: rgba(52, 159, 173, 1);
}

        button.s8-button.s8-tertiary:active {
        border-color: rgba(42, 130, 141, 1);
        background-color: rgba(42, 130, 141, 1);
        color: rgba(42, 130, 141, 1);
}

        button.s8-button.s8-tertiary:active :global(svg) {
        stroke: rgba(42, 130, 141, 1);
}

        button.s8-button.s8-quaternary {
        border-color: rgba(136, 121, 185, 1);
        background-color: rgba(136, 121, 185, 1);
        color: rgba(136, 121, 185, 1);
}

        button.s8-button.s8-quaternary :global(svg) {
        stroke: rgba(136, 121, 185, 1);
}

        button.s8-button.s8-quaternary:hover:not(:disabled) {
        border-color: rgba(102, 83, 162, 1);
        background-color: rgba(102, 83, 162, 1);
        color: rgba(102, 83, 162, 1);
}

        button.s8-button.s8-quaternary:hover:not(:disabled) :global(svg) {
        stroke: rgba(102, 83, 162, 1);
}

        button.s8-button.s8-quaternary:active {
        border-color: rgba(85, 69, 135, 1);
        background-color: rgba(85, 69, 135, 1);
        color: rgba(85, 69, 135, 1);
}

        button.s8-button.s8-quaternary:active :global(svg) {
        stroke: rgba(85, 69, 135, 1);
}

        button.s8-button.s8-danger {
        border-color: rgba(239, 35, 59, 1);
        background-color: rgba(239, 35, 59, 1);
        color: rgba(239, 35, 59, 1);
}

        button.s8-button.s8-danger :global(svg) {
        stroke: rgba(239, 35, 59, 1);
}

        button.s8-button.s8-danger:hover:not(:disabled) {
        border-color: rgba(219, 18, 42, 1);
        background-color: rgba(219, 18, 42, 1);
        color: rgba(219, 18, 42, 1);
}

        button.s8-button.s8-danger:hover:not(:disabled) :global(svg) {
        stroke: rgba(219, 18, 42, 1);
}

        button.s8-button.s8-danger:active {
        border-color: rgba(194, 6, 29, 1);
        background-color: rgba(194, 6, 29, 1);
        color: rgba(194, 6, 29, 1);
}

        button.s8-button.s8-danger:active :global(svg) {
        stroke: rgba(194, 6, 29, 1);
}

        button.s8-button.s8-warning {
        border-color: rgba(245, 192, 32, 1);
        background-color: rgba(245, 192, 32, 1);
        color: rgba(245, 192, 32, 1);
}

        button.s8-button.s8-warning :global(svg) {
        stroke: rgba(245, 192, 32, 1) !important;
}

        button.s8-button.s8-warning:hover:not(:disabled) {
        border-color: rgba(233, 174, 12, 1);
        background-color: rgba(233, 174, 12, 1);
        color: rgba(233, 174, 12, 1);
}

        button.s8-button.s8-warning:hover:not(:disabled) :global(svg) {
        stroke: rgba(233, 174, 12, 1) !important;
}

        button.s8-button.s8-warning:active {
        border-color: rgba(194, 145, 10, 1);
        background-color: rgba(194, 145, 10, 1);
        color: rgba(194, 145, 10, 1);
}

        button.s8-button.s8-warning:active :global(svg) {
        stroke: rgba(194, 145, 10, 1) !important;
}

        button.s8-button.s8-quinary {
        border-color: rgba(183, 164, 183, 1);
        background-color: rgba(183, 164, 183, 1);
        color: rgba(183, 164, 183, 1);
}

        button.s8-button.s8-quinary :global(svg) {
        stroke: rgba(183, 164, 183, 1);
}

        button.s8-button.s8-quinary:hover:not(:disabled) {
        border-color: rgba(137, 108, 137, 1);
        background-color: rgba(137, 108, 137, 1);
        color: rgba(137, 108, 137, 1);
}

        button.s8-button.s8-quinary:hover:not(:disabled) :global(svg) {
        stroke: rgba(137, 108, 137, 1);
}

        button.s8-button.s8-quinary:active {
        border-color: rgba(91, 72, 91, 1);
        background-color: rgba(91, 72, 91, 1);
        color: rgba(91, 72, 91, 1);
}

        button.s8-button.s8-quinary:active :global(svg) {
        stroke: rgba(91, 72, 91, 1);
}

        button.s8-button.s8-dark {
        border-color: rgba(39, 39, 17, 1);
        background-color: rgba(39, 39, 17, 1);
        color: rgba(255, 255, 255, 1);
}

        button.s8-button.s8-dark :global(svg) {
        stroke: rgba(255, 255, 255, 1);
}

        button.s8-button.s8-dark:hover:not(:disabled) {
        --tw-border-opacity: 1;
        border-color: rgb(0 0 0 / var(--tw-border-opacity));
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0 / var(--tw-bg-opacity));
        color: rgba(255, 255, 255, 1);
}

        button.s8-button.s8-dark:hover:not(:disabled) :global(svg) {
        stroke: rgba(255, 255, 255, 1);
}

        button.s8-button.s8-dark:active {
        --tw-border-opacity: 1;
        border-color: rgb(0 0 0 / var(--tw-border-opacity));
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0 / var(--tw-bg-opacity));
        color: rgba(255, 255, 255, 1);
}

        button.s8-button.s8-dark:active :global(svg) {
        stroke: rgba(255, 255, 255, 1);
}

        button.s8-button.s8-dark.s8-ghost,
            button.s8-button.s8-dark.s8-outline {
        color: rgba(39, 39, 17, 1);
}

        button.s8-button.s8-dark.s8-ghost :global(svg), button.s8-button.s8-dark.s8-outline :global(svg) {
        stroke: rgba(39, 39, 17, 1);
}

        button.s8-button.s8-neutral {
        border-color: rgba(193, 192, 189, 1);
        background-color: rgba(193, 192, 189, 1);
}

        button.s8-button.s8-neutral.s8-outline {
        color: rgba(193, 192, 189, 1);
}

        button.s8-button.s8-neutral :global(svg) {
        stroke: rgba(193, 192, 189, 1);
}

        button.s8-button.s8-neutral:hover:not(:disabled) {
        border-color: rgba(151, 150, 145, 1);
        background-color: rgba(151, 150, 145, 1);
        color: rgba(151, 150, 145, 1);
}

        button.s8-button.s8-neutral:hover:not(:disabled) :global(svg) {
        stroke: rgba(151, 150, 145, 1);
}

        button.s8-button.s8-neutral:active {
        border-color: rgba(112, 111, 108, 1);
        background-color: rgba(112, 111, 108, 1);
        color: rgba(112, 111, 108, 1);
}

        button.s8-button.s8-neutral:active :global(svg) {
        stroke: rgba(112, 111, 108, 1);
}

        /* Alignments */

        button.s8-button:s8:not(.s8-no-label).s8-right :global(svg) {
        margin-left: 0.25rem;
}

        button.s8-button:s8:not(.s8-no-label).s8-left :global(svg) {
        margin-right: 0.25rem;
}

        /* Sizes */

        button.s8-button.s8-xxs {
            border-radius: 3px;
            padding: 0px 5px;
            font-size: 10px;
            height: 16px;
        }

        button.s8-button.s8-xxs :global(svg) {
        height: 0.75rem;
}

        button.s8-button.s8-xs {
        height: 1.5rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        font-size: 0.75rem;
        line-height: 1rem;
            border-radius: 4px;
}

        button.s8-button.s8-xs :global(svg) {
        height: 0.875rem;
}

        button.s8-button.s8-sm {
        height: 2.125rem;
        padding-left: 0.75rem;
        padding-right: 0.75rem;
        font-size: 0.75rem;
        line-height: 1rem;
}

        button.s8-button.s8-sm :global(svg) {
        height: 0.875rem;
}

        button.s8-button.s8-md {
            height: 36px;
            padding: 0px 10px;
            font-size: 12px;
        }

        button.s8-button.s8-md :global(svg) {
        height: 1rem;
}

        button.s8-button.s8-lg {
        height: 2.625rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 1.125rem;
        line-height: 1.75rem;
}

        button.s8-button.s8-lg :global(svg) {
        height: 1.25rem;
}

        /* Styles */

        button.s8-button.s8-solid {
        color: rgba(255, 255, 255, 1) !important;
}

        button.s8-button.s8-solid :global(svg) {
        stroke: rgba(255, 255, 255, 1) !important;
}

        button.s8-button.s8-solid:hover,
            button.s8-button.s8-solid:active {
        color: rgba(255, 255, 255, 1) !important;
}

        button.s8-button.s8-solid:hover :global(svg), button.s8-button.s8-solid:active :global(svg) {
        stroke: rgba(255, 255, 255, 1) !important;
}

        button.s8-button.s8-outline {
        background-color: transparent !important;
}

        button.s8-button.s8-outline.s8-danger:hover,
            button.s8-button.s8-outline.s8-danger:active {
        border-color: rgba(219, 18, 42, 1) !important;
        background-color: rgba(231, 231, 230, 1) !important;
        color: rgba(219, 18, 42, 1) !important;
}

        button.s8-button.s8-outline.s8-danger:hover :global(svg), button.s8-button.s8-outline.s8-danger:active :global(svg) {
        stroke: rgba(219, 18, 42, 1) !important;
}

        button.s8-button.s8-outline.s8-dark:hover,
            button.s8-button.s8-outline.s8-dark:active {
        --tw-border-opacity: 1 !important;
        border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
        background-color: rgba(231, 231, 230, 1) !important;
        --tw-text-opacity: 1 !important;
        color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}

        button.s8-button.s8-outline.s8-dark:hover :global(svg), button.s8-button.s8-outline.s8-dark:active :global(svg) {
        stroke: #000 !important;
}

        button.s8-button.s8-outline.s8-neutral:hover,
            button.s8-button.s8-outline.s8-neural:active {
        border-color: rgba(151, 150, 145, 1) !important;
        background-color: rgba(231, 231, 230, 1) !important;
        color: rgba(151, 150, 145, 1) !important;
}

        button.s8-button.s8-outline.s8-neutral:hover :global(svg), button.s8-button.s8-outline.s8-neural:active :global(svg) {
        stroke: rgba(151, 150, 145, 1) !important;
}

        button.s8-button.s8-outline.s8-primary:hover,
            button.s8-button.s8-outline.s8-prinary:active {
        border-color: rgba(45, 96, 67, 1) !important;
        background-color: rgba(231, 231, 230, 1) !important;
        color: rgba(45, 96, 67, 1) !important;
}

        button.s8-button.s8-outline.s8-primary:hover :global(svg), button.s8-button.s8-outline.s8-prinary:active :global(svg) {
        stroke: rgba(45, 96, 67, 1) !important;
}

        button.s8-button.s8-outline.s8-quaternary:hover,
            button.s8-button.s8-outline.s8-quaternary:active {
        border-color: rgba(102, 83, 162, 1) !important;
        background-color: rgba(231, 231, 230, 1) !important;
        color: rgba(102, 83, 162, 1) !important;
}

        button.s8-button.s8-outline.s8-quaternary:hover :global(svg), button.s8-button.s8-outline.s8-quaternary:active :global(svg) {
        stroke: rgba(102, 83, 162, 1) !important;
}

        button.s8-button.s8-outline.s8-quinary:hover,
            button.s8-button.s8-outline.s8-quinary:active {
        border-color: rgba(137, 108, 137, 1) !important;
        background-color: rgba(231, 231, 230, 1) !important;
        color: rgba(137, 108, 137, 1) !important;
}

        button.s8-button.s8-outline.s8-quinary:hover :global(svg), button.s8-button.s8-outline.s8-quinary:active :global(svg) {
        stroke: rgba(137, 108, 137, 1) !important;
}

        button.s8-button.s8-ghost {
        border-color: transparent !important;
        background-color: transparent !important;
        padding-left: 0px;
        padding-right: 0px;
}

        button.s8-button.s8-ghost.s8-dark :global(svg), button.s8-button.s8-ghost.s8-dark:hover :global(svg), button.s8-button.s8-ghost.s8-dark:active :global(svg) {
        stroke: rgba(39, 39, 17, 1) !important;
}

        button.s8-button.s8-ghost:hover {
        background-color: rgba(231, 231, 230, 1) !important;
}

        button.s8-button.s8-ghost:active {
        border-color: transparent !important;
        background-color: transparent !important;
}

        button.s8-button.s8-ghost:active :global(svg) {
        stroke: rgba(39, 39, 17, 1) !important;
}

        button.s8-button:disabled {
        cursor: not-allowed;
        color: rgba(248, 248, 248, 1);
}

        button.s8-button:disabled :global(svg) {
        stroke: rgba(248, 248, 248, 1) !important;
}

        button.s8-button:disabled.s8-solid {
        border-color: rgba(248, 248, 248, 1);
        background-color: rgba(231, 231, 230, 1);
        color: rgba(193, 192, 189, 1) !important;
}

        button.s8-button:disabled.s8-solid:hover {
        border-color: rgba(248, 248, 248, 1);
        background-color: rgba(231, 231, 230, 1);
}

        button.s8-button:disabled.s8-outline {
        border-color: rgba(248, 248, 248, 1);
}

        button.s8-button:disabled.s8-outline:hover {
        border-color: rgba(248, 248, 248, 1);
}

        button.s8-button:disabled.s8-outline:hover :global(svg) {
        stroke: rgba(248, 248, 248, 1) !important;
}</style>

<!-- eslint-enable max-len -->